import type { Match, Query } from '@atlassian/react-resource-router';
import { getProjectKeyId } from '../get-project-key-id/index.tsx';

export const getProjectKeyOrId = (match: Match) => {
	const { projectKey, projectId } = getProjectKeyId(match, match.query);
	return projectKey || projectId || '';
};

export const getProjectKeyOrIdFromMatchAndQuery = ({
	match,
	query,
}: {
	match: Match;
	query: Query;
}) => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};
